/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { FormType, formTypeIcon, formTypeIconDefaultFill } from 'cio/utils/forms';

interface FormsFormTypeIconArgs {
  type: FormType;
  fill?: string;
  size?: string;
}

export default class FormsFormTypeIcon extends Component<FormsFormTypeIconArgs> {
  get icon() {
    return formTypeIcon(this.args.type);
  }

  get fill() {
    return this.args.fill ?? formTypeIconDefaultFill(this.args.type);
  }
}
